module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }